var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 299.3 74.3"
    },
    xmlSpace: "preserve",
    viewBox: "0 0 115.5 74.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " \t\t.st0{fill:#FFFFFF;} \t\t.st1{fill:#ED5338;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "63.3,0 63.3,24.2 94.2,59.3 63.3,59.3 63.3,74.3 107.5,74.3 115.5,59.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.2,59.3 21.3,59.3 52.2,24.2 52.2,0 47.1,5.8 0,59.3 8.1,74.3 52.2,74.3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu-logo.f93a7119fa1b8634017b29e5d18e6df6.svg";
export { ForwardRef as ReactComponent };